export type ReservationStatusType = "sr"|"nn"|"res"|"pag"|"wtf"
export type ReservationType = {
  _id: string, 
  activityId: ?string, 
  baseImponible: number, 
  date: string, // YYYY/MM/DD
  finalPrice: ?number, 
  itemKey: string,
  iva0: number, 
  iva10: number, 
  iva21: number, 
  iva4: number, 
  name: string, 
  notes: ?string, 
  receipt: ?string,
  receiptDate: ?string, 
  status: ReservationStatusType, 
  supplier: ?string,
  time: ?(string|string[]), 
  tripId: string, 
  type: "activity"|"expense", 
}

const emptyReservation: ReservationType = { 
  _id: "", 
  activityId: null, 
  baseImponible: 0, 
  date: "", // YYYY/MM/DD
  finalPrice: null, 
  itemKey: "",
  iva0: 0, 
  iva10: 0, 
  iva21: 0, 
  iva4: 0, 
  name: "", 
  notes: "", 
  receipt: "",
  receiptDate: "", 
  status: "sr", 
  supplier: null,
  time: "", 
  tripId: null, 
  type: "activity", 
}

export default emptyReservation

